module.exports = __webpack_public_path__ + "img/rise_jeans_high.c56062b0.jpg";